// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"228":"5a0f34b3","355":"14edcd5b","361":"3e42ab5c","365":"63a33a8f","501":"3c5b06ff","523":"37f886f5","695":"2ce75960","733":"7ab90ae9","764":"4783173e","835":"602fd349","902":"c9d7dc67","912":"93a24ee3","978":"59c0667e"}[chunkId] + ".chunk.js";
};